import { render } from "./BuyerNavDashboardGridIcon.vue?vue&type=template&id=dcfc5020"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__